















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { format } from "date-fns";
import numbro from "numbro";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { minValue, requiredIf } from "vuelidate/lib/validators";
import {
  ProformaDetailsManagementDef,
  ProformaManagementDef,
  SelectOptionDef,
  ShipmentManagementDef,
  TranslatedCountryDTO
} from "../../../model/component.model";
import {
  ConfigurationDTO,
  CountryDTO,
  CurrenciesDTO,
  MeasurementUnitsDTO,
  ZonosCalculateResponseDTO,
  ZonosCalculateResponseItemDTO
} from "../../../model/data.model";
import {
  getMultiStoreId,
  getTenantId,
  getStoreId
} from "../../../services/AuthService";
import { GenericService } from "../../../services/GenericService";
import ProformaService from "../../../services/ProformaService";
import Accordion from "../../shared/Accordion.vue";
import {
  fieldSorter,
  isFrance,
  isGermany,
  isPoland,
  isPortugal,
  isUk
} from "@/services/Helpers";
import ProformaModalLine from "./ProformaModalLine.vue";
import store from "@/vuex/store";
import { alertDangerReason, popupFileBase64 } from "@/services/Helpers";
import { Validations } from "vuelidate-property-decorators";
import i18n, { hasTranslation } from "@/lang/i18n";
import { ShipmentService } from "@/services/ShipmentService";
import { getCurrencies } from "@/services/AuthService";
import { cloneDeep } from "lodash";

@Component({
  components: {
    MbeAccordion: Accordion,
    MbeProformaModalLine: ProformaModalLine
  }
})
export default class ProformaModal extends Vue {
  @Validations()
  validations() {
    return {
      proforma: {
        proformaDetails: {
          $each: {
            itemsSingleValue: {}
          }
        },
        language: {
          required: requiredIf(() => this.showTaxDutyLogic)
        },
        totalValue: {
          minValue: minValue(0.01)
        },
        invoiceType: {
          required: requiredIf(
            () =>
              !this.germany ||
              this.isGermanyAndCourierDHL ||
              this.isGermanyAndCourierUPS
          )
        },
        mbeReasonCode: {
          required: requiredIf(
            () =>
              !this.germany ||
              this.isGermanyAndCourierDHL ||
              this.isGermanyAndCourierUPS
          )
        },
        declarationStatement: {
          required: requiredIf(() => this.uk)
        },
        vatStatus: {
          required: requiredIf(() => this.uk)
        },
        vatNumber: {
          required: requiredIf(isPortugal())
        },
        receiverVatNumber: {
          required: requiredIf(isPortugal())
        }
      }
    };
  }

  @Prop() shipment: ShipmentManagementDef;

  languages = [
    { value: "it", label: i18n.t("it") },
    { value: "en", label: i18n.t("en") },
    { value: "de", label: i18n.t("de") },
    { value: "es", label: i18n.t("es") },
    { value: "ca", label: i18n.t("ca") },
    { value: "pl", label: i18n.t("pl") },
    { value: "pt", label: i18n.t("pt") },
    { value: "fr", label: i18n.t("fr") }
  ] as SelectOptionDef[];

  proforma: ProformaManagementDef = {
    invoiceDate: format(new Date(), "yyyy-MM-dd")
  } as ProformaManagementDef;
  mus: MeasurementUnitsDTO[] = [];
  currencies: CurrenciesDTO[] = [];
  currency: any = "";
  countries: CountryDTO[] = [];
  incoterms = [] as SelectOptionDef[];
  possibleSenders = ["customer", "sender", "receiver"];
  possibleReceivers = ["customer", "sender", "receiver"];
  proformaSenderType = "";
  proformaReceiverType = "";

  proformaService: ProformaService;
  genericService: GenericService;

  invoiceTypes = [
    { label: this.$t("commercial"), value: "COMMERCIAL" },
    { label: this.$t("proforma"), value: "PROFORMA" }
  ];

  declarationStatements = [{ label: "", value: "" }];

  vatStatusValues = [{ label: "", value: "" }];

  reasonValues = [{ label: "", value: "" }];

  weightVisible = true;

  tariffUrlFound = false;
  tariffUrl = "";

  MRNVisibility = false;

  get proformaTotalValue() {
    return this.proforma.totalValue
      ? this.formatNumber(this.proforma.totalValue)
      : this.formatNumber(0);
  }

  get zonosInvalidItems() {
    return this.$store.getters[
      "shipment/zonosInvalidItems"
    ] as ZonosCalculateResponseItemDTO[];
  }

  get isItemInvalid() {
    return (item: ProformaDetailsManagementDef) => {
      if (!this.zonosInvalidItems || !this.zonosInvalidItems.length)
        return false;
      return this.zonosInvalidItems.some(
        (el: ZonosCalculateResponseItemDTO) => {
          return Number(item.position) === Number(el.position);
        }
      );
    };
  }

  get defaultStoreCurrency() {
    return this.$store.getters["customer/storeInfo"].store.currency as string;
  }

  get zonosCalculateResponse() {
    return this.$store.getters[
      "shipment/zonosCalculateResponse"
    ] as null | ZonosCalculateResponseDTO;
  }

  vatNumberReadOnly = false;

  handleSenderVatNumber(invoiceType: string, isDDPIncotermSelected: boolean) {
    if (
      this.zonosCalculateResponse === null ||
      invoiceType !== "COMMERCIAL" ||
      !isDDPIncotermSelected
    ) {
      this.vatNumberReadOnly = false;
      return;
    }
    this.vatNumberReadOnly = true;
  }

  get hasDDPIncotermSelected() {
    if (!this.showTaxDutyLogic) return false;
    return this.selectedIncoterm && this.selectedIncoterm.value === "DDP";
  }

  @Watch("proforma.invoiceType", { immediate: true })
  onProformaInvoiceTypeChange(newType: string) {
    this.handleSenderVatNumber(newType, this.hasDDPIncotermSelected);
  }

  @Watch("hasDDPIncotermSelected")
  onHasDDPIncotermSelected(status: boolean) {
    this.handleSenderVatNumber(this.proforma.invoiceType, status);
  }

  get selectedIncoterm(): SelectOptionDef | null {
    if (this.proforma.incoterms !== "") {
      return this.incoterms.filter(
        item => item.value === this.proforma.incoterms
      )[0];
    } else {
      return null;
    }
  }

  set selectedIncoterm(i: SelectOptionDef | null) {
    if (i !== null) {
      this.proforma.incoterms = i.label;
    }
  }

  get showTaxDutyLogic() {
    return (
      this.$store.getters["shipment/enableTaxDutySection"] &&
      this.isTaxDutyEnabled
    );
  }

  get isTaxDutyEnabled() {
    return this.$store.getters["customer/isTaxDutyEnabled"] as boolean;
  }

  created() {
    this.genericService = new GenericService();
    this.proformaService = new ProformaService();
    ShipmentService.prototype
      .getShipmentKeys([
        {
          tenantId: getTenantId(),
          confKey: "TARIFF_CODES_LINK"
        }
      ] as any)
      .then((res: ConfigurationDTO[]) => {
        this.tariffUrl = this.extractConfiguration(
          res,
          "TARIFF_CODES_LINK"
        ).confValue;
        if (this.tariffUrl && this.tariffUrl !== "") {
          this.tariffUrlFound = true;
        }
      });
    this.loadData();
    ShipmentService.prototype.getReasons().then((res: any) => {
      this.reasonValues = res;
    });
    ShipmentService.prototype
      .getProformaDeclarationStatements()
      .then((res: any) => {
        this.declarationStatements = res;
      });
    ShipmentService.prototype.getProformaVatStatuses().then((res: any) => {
      this.vatStatusValues = res;
    });
    if (isPortugal()) {
      this.invoiceTypes = this.invoiceTypes.filter(
        item => item.value === "PROFORMA"
      );
    }
    ShipmentService.prototype
      .getShipmentKeys([
        {
          tenantId: getTenantId(),
          multistoreId: getMultiStoreId(),
          storeId: getStoreId(),
          confKey: "SYS_ACTIVATION_PROFORMA_MRN_COURIER"
        }
      ] as any)
      .then((res: ConfigurationDTO[]) => {
        if (!this.shipment.courierId) {
          this.MRNVisibility = false;
        } else {
          let config = res.find(
            conf => conf.confKey === "SYS_ACTIVATION_PROFORMA_MRN_COURIER"
          );
          if (!config) {
            config = {
              confKey: "SYS_ACTIVATION_PROFORMA_MRN_COURIER",
              confValue: ""
            } as ConfigurationDTO;
          }
          const visibleCouriers = config.confValue.split(";");
          const courierFound = visibleCouriers.find(
            el => el == String(this.shipment.courierId)
          );
          this.MRNVisibility = !!courierFound;
          if (
            !visibleCouriers ||
            visibleCouriers.length == 0 ||
            visibleCouriers[0] == ""
          ) {
            ShipmentService.prototype
              .getShipmentKeys([
                {
                  tenantId: getTenantId(),
                  multistoreId: getMultiStoreId(),
                  confKey: "SYS_ACTIVATION_PROFORMA_MRN_COURIER"
                }
              ] as any)
              .then((res: ConfigurationDTO[]) => {
                let config = res.find(
                  conf => conf.confKey === "SYS_ACTIVATION_PROFORMA_MRN_COURIER"
                );
                if (!config) {
                  config = {
                    confKey: "SYS_ACTIVATION_PROFORMA_MRN_COURIER",
                    confValue: ""
                  } as ConfigurationDTO;
                }
                const visibleCouriers = config.confValue.split(";");
                const courierFound = visibleCouriers.find(
                  el => el == String(this.shipment.courierId)
                );
                this.MRNVisibility = !!courierFound;
                if (
                  !visibleCouriers ||
                  visibleCouriers.length == 0 ||
                  visibleCouriers[0] == ""
                ) {
                  ShipmentService.prototype
                    .getShipmentKeys([
                      {
                        tenantId: getTenantId(),
                        confKey: "SYS_ACTIVATION_PROFORMA_MRN_COURIER"
                      }
                    ] as any)
                    .then((res: ConfigurationDTO[]) => {
                      let config = res.find(
                        conf =>
                          conf.confKey === "SYS_ACTIVATION_PROFORMA_MRN_COURIER"
                      );
                      if (!config) {
                        config = {
                          confKey: "SYS_ACTIVATION_PROFORMA_MRN_COURIER",
                          confValue: ""
                        } as ConfigurationDTO;
                      }
                      const visibleCouriers = config.confValue.split(";");
                      const courierFound = visibleCouriers.find(
                        el => el == String(this.shipment.courierId)
                      );
                      this.MRNVisibility = !!courierFound;
                    });
                }
              });
          }
        }
      });
  }

  async loadData() {
    const tempMus: MeasurementUnitsDTO[] = await store.cache.dispatch(
      "cachemod/getProformaMeasurementUnits"
    );
    this.mus = tempMus.filter(item =>
      isPortugal() ? item.code === "PCS" : true
    );

    const tempCountries = await store.cache.dispatch("cachemod/getCountries");
    tempCountries.sort((a: CountryDTO, b: CountryDTO) =>
      a.name < b.name ? -1 : 1
    );
    this.countries = tempCountries
      .filter(item => {
        return isPortugal() ? item.id === "PT" : true;
      })
      .map(
        (country: CountryDTO): TranslatedCountryDTO => {
          const translatedCountry = {
            ...country
          } as TranslatedCountryDTO;
          translatedCountry.translatedName = this.$t(
            "country_" + country.id
          ).toString();
          return translatedCountry;
        }
      )
      .sort(fieldSorter(["translatedName"]));

    getCurrencies().then(res => {
      this.currencies = res;
    });

    if (this.shipment.shipmentId) {
      this.proformaService
        .getProforma(this.shipment.shipmentId)
        .then((res: any) => {
          if (res.proformaDetails && res.proformaDetails.length > 0) {
            res.proformaDetails.forEach(line => {
              if (line.mbeMeasureUnitCode && !line.measureOfMeasurement) {
                line.measureOfMeasurement = this.mus.find(
                  unit => unit.code === line.mbeMeasureUnitCode
                ).description;
              }
            });
          }

          this.proforma = cloneDeep(res);
          if (!this.proforma.language)
            this.proforma.language = this.userLanguage;

          //Detect description lines...
          let i = 0;
          if (this.proforma.proformaDetails != undefined) {
            this.proforma.proformaDetails.forEach(
              (detail: ProformaDetailsManagementDef) => {
                if (detail.itemsNumber == 0) {
                  this.proforma.proformaDetails[i].type = 2;
                } else {
                  this.proforma.proformaDetails[i].type = 1;
                }
                i++;
              }
            );
          }

          if (!this.proforma.senderCompanyName) {
            this.proforma.senderCompanyName = this.shipment.addressFor.companyName;
            this.proforma.senderAddress = this.shipment.addressFor.address;
            this.proforma.senderCity = this.shipment.addressFor.city;
            this.proforma.senderProvince = this.shipment.addressFor.province;
            this.proforma.senderZipCode = this.shipment.addressFor.zipCode;
            this.proforma.senderCountryName = this.shipment.addressFor.countryId;
            this.proforma.senderPhone = this.shipment.addressFor.phone;
          }
          if (!this.proforma.vatNumber) {
            //init vat from customer on new shipment
            this.proforma.vatNumber = this.$store.getters["customer/info"]
              .vatNumber
              ? this.$store.getters["customer/info"].vatNumber
              : "";
          }
          if (!this.proforma.fiscalCode) {
            //init vat from customer on new shipment
            this.proforma.fiscalCode = this.$store.getters["customer/info"]
              .fiscalCode
              ? this.$store.getters["customer/info"].fiscalCode
              : "";
          }
          if (!this.proforma.eori) {
            //init vat from customer on new shipment
            this.proforma.eori = this.$store.getters["customer/info"].eori
              ? this.$store.getters["customer/info"].eori
              : "";
          }
          if (this.shipment.customerDepartmentId) {
            this.proformaSenderType = this.proforma.proformaSenderType
              ? this.proforma.proformaSenderType
              : "department";
          } else {
            this.proformaSenderType =
              this.proforma.proformaSenderType &&
              this.proforma.proformaSenderType !== "department"
                ? this.proforma.proformaSenderType
                : "customer";
          }

          this.proformaReceiverType = this.proforma.proformaReceiverType
            ? this.proforma.proformaReceiverType
            : "receiver";

          if (
            JSON.parse(JSON.stringify(res)) == JSON.parse(JSON.stringify({})) ||
            !res ||
            res.proformaDetails.length == 0
          ) {
            this.changeReceiver();
            this.changeSender();
          }

          this.applyGoodDescription();
        });
    } else if (this.shipment.proforma) {
      const p = this.shipment.proforma;
      this.proforma = {
        invoiceNumber:
          p.invoiceNumber !== undefined
            ? p.invoiceNumber
            : String(format(new Date(), "yyyyMMddHHmm")),
        invoiceDate:
          p.invoiceDate !== undefined
            ? p.invoiceDate
            : format(new Date(), "yyyy-MM-dd"),
        declarationText:
          p.declarationText !== undefined ? p.declarationText : "",
        additionalComment:
          p.additionalComment !== undefined ? p.additionalComment : "",
        currency: this.shipment.proforma.currency,
        language: this.shipment.proforma.language,
        eori: p.eori !== undefined ? p.eori : "",
        totalValue: this.shipment.proforma.totalValue,
        proformaDetails:
          p.proformaDetails !== undefined
            ? p.proformaDetails
            : ([] as ProformaDetailsManagementDef[]),
        incoterms: p.incoterms !== undefined ? p.incoterms : "",
        vatNumber: p.vatNumber !== undefined ? p.vatNumber : "",
        fiscalCode: p.fiscalCode !== undefined ? p.fiscalCode : "",
        proformaReceiverType:
          p.proformaReceiverType !== undefined ? p.proformaReceiverType : "",
        proformaSenderType:
          p.proformaSenderType !== undefined ? p.proformaSenderType : "",
        receiverVatNumber:
          p.receiverVatNumber !== undefined ? p.receiverVatNumber : "",
        receiverFiscalCode:
          p.receiverFiscalCode !== undefined ? p.receiverFiscalCode : "",
        receiverEori: p.receiverEori !== undefined ? p.receiverEori : "",
        senderCompanyName:
          p.senderCompanyName != undefined
            ? p.senderCompanyName
            : this.shipment.addressFor.companyName,
        senderAddress:
          p.senderAddress != undefined
            ? p.senderAddress
            : this.shipment.addressFor.address,
        senderCity:
          p.senderCity != undefined
            ? p.senderCity
            : this.shipment.addressFor.city,
        senderProvince:
          p.senderProvince != undefined
            ? p.senderProvince
            : this.shipment.addressFor.province,
        senderZipCode:
          p.senderZipCode != undefined
            ? p.senderZipCode
            : this.shipment.addressFor.zipCode,
        senderCountryName:
          p.senderCountryName != undefined
            ? p.senderCountryName
            : this.shipment.addressFor.countryId,
        senderCountryId: p.senderCountryId,
        senderPhone:
          p.senderPhone != undefined
            ? p.senderPhone
            : this.shipment.addressFor.phone,
        receiverCompanyName:
          p.receiverCompanyName != undefined
            ? p.receiverCompanyName
            : this.shipment.addressTo.companyName,
        receiverAddress:
          p.receiverAddress != undefined
            ? p.receiverAddress
            : this.shipment.addressTo.address,
        receiverCity:
          p.receiverCity != undefined
            ? p.receiverCity
            : this.shipment.addressTo.city,
        receiverProvince:
          p.receiverProvince != undefined
            ? p.receiverProvince
            : this.shipment.addressTo.province,
        receiverZipCode:
          p.receiverZipCode != undefined
            ? p.receiverZipCode
            : this.shipment.addressTo.zipCode,
        receiverCountryName:
          p.receiverCountryName != undefined
            ? p.receiverCountryName
            : this.shipment.addressTo.countryId,
        receiverCountryId: p.receiverCountryId,
        receiverPhone:
          p.receiverPhone != undefined
            ? p.receiverPhone
            : this.shipment.addressTo.phone,
        invoiceType: p.invoiceType !== undefined ? p.invoiceType : null,
        mbeReasonCode: p.mbeReasonCode !== undefined ? p.mbeReasonCode : "",
        declarationStatement: p.declarationStatement,
        vatStatus: p.vatStatus,
        mrnNumber: p.mrnNumber !== undefined ? p.mrnNumber : ""
      } as ProformaManagementDef;
    }

    this.applyGoodDescription();

    if (!this.proforma.vatNumber) {
      //init vat from customer on new shipment
      this.proforma.vatNumber = this.shipment.addressFrom.vatNumber
        ? this.shipment.addressFrom.vatNumber
        : "";
    }

    if (!this.proforma.eori) {
      //init eori from customer on new shipment
      this.proforma.eori = this.shipment.addressFrom.eori
        ? this.shipment.addressFrom.eori
        : "";
    }

    if (!this.proforma.fiscalCode) {
      //init fiscalCode from customer on new shipment
      this.proforma.fiscalCode = this.shipment.addressFrom.fiscalCode
        ? this.shipment.addressFrom.fiscalCode
        : "";
    }

    if (!this.proforma.incoterms) {
      this.setDefaultIncoterms();
    }

    this.incotermsType.forEach((incoterm: any) => {
      this.incoterms.push({ label: incoterm, value: incoterm });
    });
    this.proformaSenderType = this.proforma.proformaSenderType
      ? this.proforma.proformaSenderType
      : "customer";
    this.proformaReceiverType = this.proforma.proformaReceiverType
      ? this.proforma.proformaReceiverType
      : "receiver";
    if (this.shipment.customerDepartmentId) {
      this.possibleSenders = ["customer", "department", "sender", "receiver"];
      this.possibleReceivers = ["customer", "department", "sender", "receiver"];
      this.proformaSenderType = this.proforma.proformaSenderType
        ? this.proforma.proformaSenderType
        : "department";
      if (
        !this.proforma.proformaDetails ||
        this.proforma.proformaDetails.length == 0
      )
        this.changeSender();
      if (
        !this.proforma.proformaDetails ||
        this.proforma.proformaDetails.length == 0
      )
        this.changeReceiver();
    } else {
      this.proformaSenderType =
        this.proforma.proformaSenderType &&
        this.proforma.proformaSenderType !== "department"
          ? this.proforma.proformaSenderType
          : "customer";
      if (
        !this.proforma.proformaDetails ||
        this.proforma.proformaDetails.length == 0
      )
        this.changeSender();
      if (
        !this.proforma.proformaDetails ||
        this.proforma.proformaDetails.length == 0
      )
        this.changeReceiver();
    }
    this.proforma.eori =
      this.shipment.proforma && this.shipment.proforma.eori
        ? this.shipment.proforma.eori
        : this.$store.getters["customer/info"].eori;
    this.proforma.fiscalCode =
      this.shipment.proforma && this.shipment.proforma.fiscalCode
        ? this.shipment.proforma.fiscalCode
        : this.$store.getters["customer/info"].fiscalCode;
    this.proforma.vatNumber =
      this.shipment.proforma && this.shipment.proforma.vatNumber
        ? this.shipment.proforma.vatNumber
        : this.$store.getters["customer/info"].vatNumber;
    this.proforma.receiverVatNumber =
      this.shipment.proforma && this.shipment.proforma.receiverVatNumber
        ? this.shipment.proforma.receiverVatNumber
        : "";
    this.proforma.receiverEori =
      this.shipment.proforma && this.shipment.proforma.receiverEori
        ? this.shipment.proforma.receiverEori
        : "";
    this.proforma.receiverFiscalCode =
      this.shipment.proforma && this.shipment.proforma.receiverFiscalCode
        ? this.shipment.proforma.receiverFiscalCode
        : "";
    this.proforma.mrnNumber =
      this.shipment.proforma && this.shipment.proforma.mrnNumber
        ? this.shipment.proforma.mrnNumber
        : "";
  }

  changeSender() {
    this.proforma.proformaSenderType = this.proformaSenderType;
    if (
      (this.proformaSenderType === "customer" &&
        !this.possibleSenders.includes("department")) ||
      this.proformaSenderType === "department"
    ) {
      this.proforma.senderCompanyName = this.shipment.addressFor.companyName;
      this.proforma.senderAddress = this.shipment.addressFor.address;
      this.proforma.senderCity = this.shipment.addressFor.city;
      this.proforma.senderProvince = this.shipment.addressFor.province;
      this.proforma.senderZipCode = this.shipment.addressFor.zipCode;
      this.proforma.senderCountryName = this.shipment.addressFor.countryName;
      this.proforma.senderCountryId = this.shipment.addressFor.countryId;
      this.proforma.senderPhone = this.shipment.addressFor.phone;
      this.proforma.eori = this.$store.getters["customer/info"].eori;
      this.proforma.fiscalCode = this.$store.getters[
        "customer/info"
      ].fiscalCode;
      this.proforma.vatNumber = this.$store.getters["customer/info"].vatNumber;
    }
    if (
      this.proformaSenderType === "customer" &&
      this.possibleSenders.includes("department")
    ) {
      this.proforma.senderCompanyName = this.$store.getters[
        "customer/info"
      ].businessName;
      this.proforma.senderAddress = this.$store.getters[
        "customer/info"
      ].address.addresses[0].address;
      this.proforma.senderCity = this.$store.getters[
        "customer/info"
      ].address.addresses[0].city;
      this.proforma.senderProvince = this.$store.getters[
        "customer/info"
      ].address.addresses[0].province;
      this.proforma.senderZipCode = this.$store.getters[
        "customer/info"
      ].address.addresses[0].zipCode;
      this.proforma.senderCountryName = this.$store.getters[
        "customer/info"
      ].address.addresses[0].countryName;
      this.proforma.senderCountryId = this.$store.getters[
        "customer/info"
      ].address.addresses[0].countryId;
      this.proforma.senderPhone = this.$store.getters[
        "customer/info"
      ].address.contactsReference.find((e: any) => e.type === "TELEPHONE1")
        ? this.$store.getters["customer/info"].address.contactsReference.find(
            (e: any) => e.type === "TELEPHONE1"
          ).value
        : "";
      this.proforma.eori = this.$store.getters["customer/info"].eori;
      this.proforma.fiscalCode = this.$store.getters[
        "customer/info"
      ].fiscalCode;
      this.proforma.vatNumber = this.$store.getters["customer/info"].vatNumber;
    }
    if (this.proformaSenderType === "sender") {
      this.proforma.senderCompanyName = this.shipment.addressFrom.companyName;
      this.proforma.senderAddress = this.shipment.addressFrom.address;
      this.proforma.senderCity = this.shipment.addressFrom.city;
      this.proforma.senderProvince = this.shipment.addressFrom.province;
      this.proforma.senderZipCode = this.shipment.addressFrom.zipCode;
      this.proforma.senderCountryName = this.shipment.addressFrom.countryName;
      this.proforma.senderCountryId = this.shipment.addressFrom.countryId;
      this.proforma.senderPhone = this.shipment.addressFrom.phone;
      this.proforma.eori = "";
      this.proforma.fiscalCode = "";
      this.proforma.vatNumber = "";
    }
    if (this.proformaSenderType === "receiver") {
      this.proforma.senderCompanyName = this.shipment.addressTo.companyName;
      this.proforma.senderAddress = this.shipment.addressTo.address;
      this.proforma.senderCity = this.shipment.addressTo.city;
      this.proforma.senderProvince = this.shipment.addressTo.province;
      this.proforma.senderZipCode = this.shipment.addressTo.zipCode;
      this.proforma.senderCountryName = this.shipment.addressTo.countryName;
      this.proforma.senderCountryId = this.shipment.addressTo.countryId;
      this.proforma.senderPhone = this.shipment.addressTo.phone;
      this.proforma.eori = "";
      this.proforma.fiscalCode = "";
      this.proforma.vatNumber = "";
    }
  }

  changeReceiver() {
    this.proforma.proformaReceiverType = this.proformaReceiverType;
    if (
      (this.proformaReceiverType === "customer" &&
        !this.possibleReceivers.includes("department")) ||
      this.proformaReceiverType === "department"
    ) {
      this.proforma.receiverCompanyName = this.shipment.addressFor.companyName;
      this.proforma.receiverSecondAddress = this.shipment.addressFor.secondAddress;
      this.proforma.receiverAddress = this.shipment.addressFor.address;
      this.proforma.receiverCity = this.shipment.addressFor.city;
      this.proforma.receiverProvince = this.shipment.addressFor.province;
      this.proforma.receiverZipCode = this.shipment.addressFor.zipCode;
      this.proforma.receiverCountryName = this.shipment.addressFor.countryName;
      this.proforma.receiverCountryId = this.shipment.addressFor.countryId;
      this.proforma.receiverPhone = this.shipment.addressFor.phone;
      this.proforma.receiverVatNumber = this.$store.getters[
        "customer/info"
      ].vatNumber;
      this.proforma.receiverFiscalCode = this.$store.getters[
        "customer/info"
      ].fiscalCode;
      this.proforma.receiverEori = this.$store.getters["customer/info"].eori;
    }
    if (
      this.proformaReceiverType === "customer" &&
      this.possibleReceivers.includes("department")
    ) {
      this.proforma.receiverCompanyName = this.$store.getters[
        "customer/info"
      ].businessName;
      this.proforma.receiverAddress = this.$store.getters[
        "customer/info"
      ].address.addresses[0].address;
      this.proforma.receiverCity = this.$store.getters[
        "customer/info"
      ].address.addresses[0].city;
      this.proforma.receiverProvince = this.$store.getters[
        "customer/info"
      ].address.addresses[0].province;
      this.proforma.receiverZipCode = this.$store.getters[
        "customer/info"
      ].address.addresses[0].zipCode;
      this.proforma.receiverCountryName = this.$store.getters[
        "customer/info"
      ].address.addresses[0].countryName;
      this.proforma.receiverCountryId = this.$store.getters[
        "customer/info"
      ].address.addresses[0].countryId;
      this.proforma.receiverPhone = this.$store.getters[
        "customer/info"
      ].address.contactsReference.find((e: any) => e.type === "TELEPHONE1")
        ? this.$store.getters["customer/info"].address.contactsReference.find(
            (e: any) => e.type === "TELEPHONE1"
          ).value
        : "";
      this.proforma.receiverVatNumber = this.$store.getters[
        "customer/info"
      ].vatNumber;
      this.proforma.receiverFiscalCode = this.$store.getters[
        "customer/info"
      ].fiscalCode;
      this.proforma.receiverEori = this.$store.getters["customer/info"].eori;
    }
    if (this.proformaReceiverType === "sender") {
      this.proforma.receiverCompanyName = this.shipment.addressFrom.companyName;
      this.proforma.receiverSecondAddress = this.shipment.addressFrom.secondAddress;
      this.proforma.receiverAddress = this.shipment.addressFrom.address;
      this.proforma.receiverCity = this.shipment.addressFrom.city;
      this.proforma.receiverProvince = this.shipment.addressFrom.province;
      this.proforma.receiverZipCode = this.shipment.addressFrom.zipCode;
      this.proforma.receiverCountryName = this.shipment.addressFrom.countryName;
      this.proforma.receiverCountryId = this.shipment.addressFrom.countryId;
      this.proforma.receiverPhone = this.shipment.addressFrom.phone;
      this.proforma.receiverVatNumber = "";
      this.proforma.receiverFiscalCode = "";
      this.proforma.receiverEori = "";
    }
    if (this.proformaReceiverType === "receiver") {
      this.proforma.receiverCompanyName = this.shipment.addressTo.companyName;
      this.proforma.receiverSecondAddress = this.shipment.addressTo.secondAddress;
      this.proforma.receiverAddress = this.shipment.addressTo.address;
      this.proforma.receiverCity = this.shipment.addressTo.city;
      this.proforma.receiverProvince = this.shipment.addressTo.province;
      this.proforma.receiverZipCode = this.shipment.addressTo.zipCode;
      this.proforma.receiverCountryName = this.shipment.addressTo.countryName;
      this.proforma.receiverCountryId = this.shipment.addressTo.countryId;
      this.proforma.receiverPhone = this.shipment.addressTo.phone;
      this.proforma.receiverVatNumber = "";
      this.proforma.receiverFiscalCode = "";
      this.proforma.receiverEori = "";
    }
  }

  private getProformaStorageKey(): string | null {
    return this.shipment && this.shipment.shipmentId
      ? "proformaAppliedGoodDescription_" + this.shipment.shipmentId
      : null;
  }

  private readAppliedGoodDescription(): string | null {
    const key = this.getProformaStorageKey();
    if (key) {
      const value = localStorage.getItem(key);
      if (value !== null) return value;
    }
    const first = Array.isArray(this.proforma.proformaDetails)
      ? this.proforma.proformaDetails[0]
      : undefined;
    const memo = first && (first as any).appliedGoodDescription;
    return memo === undefined || memo === null ? null : String(memo);
  }

  private writeAppliedGoodDescription(value: string | null): void {
    const key = this.getProformaStorageKey();
    if (key) {
      if (value === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, value);
      }
      return;
    }
    const first = Array.isArray(this.proforma.proformaDetails)
      ? this.proforma.proformaDetails[0]
      : undefined;
    if (first) {
      Object.defineProperty(first, "appliedGoodDescription", {
        value,
        enumerable: false,
        configurable: true,
        writable: true
      });
    }
  }

  private applyGoodDescription(): void {
    if (!this.shipment) return;
    const goodDescription = (this.shipment.goodDescription || "").trim();
    if (!goodDescription) return;

    const details = this.proforma.proformaDetails;
    if (!Array.isArray(details) || details.length === 0) return;

    const first = details[0];
    const current = (first.description || "").trim();
    const applied = this.readAppliedGoodDescription();

    if (applied === null) {
      if (!current) {
        this.$set(first, "description", goodDescription);
        this.writeAppliedGoodDescription(goodDescription);
      }
      return;
    }

    if (applied === "") {
      return;
    }

    if (current === applied) {
      if (applied !== goodDescription) {
        this.$set(first, "description", goodDescription);
        this.writeAppliedGoodDescription(goodDescription);
      }
      return;
    }

    this.writeAppliedGoodDescription("");
  }

  addLine(lineType: number) {
    const newLine = {
      type: lineType,
      position: this.proforma.proformaDetails.length + 1,
      countryOfOrigin: this.shipment.addressFrom.countryId,
      measureOfMeasurement: "", //<--add here the default value!
      mbeMeasureUnitCode: "",
      measureOfMeasurementSecondary: "",
      coefficient: 0,
      itemsNumber: 0,
      itemsTotalValue: 0,
      description: "",
      articleId: 0,
      itemsSingleValue: 0,
      descriptiveRow: lineType === 2
    } as ProformaDetailsManagementDef;
    if (this.weightVisible) newLine.weight = 0;
    if (this.isGermanyAndCourierDPD || this.isGermanyAndCourierDHL)
      newLine.hsCode = "";
    if (isPortugal() || this.showTaxDutyLogic) {
      newLine.measureOfMeasurement = "Pieces";
      newLine.mbeMeasureUnitCode = "PCS";
    }

    if (Array.isArray(this.proforma.proformaDetails)) {
      if (
        this.shipment &&
        (!this.shipment.proforma ||
          !this.shipment.proforma.proformaDetails ||
          (this.shipment.proforma.proformaDetails &&
            this.shipment.proforma.proformaDetails.length == 0)) &&
        this.weightVisible &&
        this.proforma.proformaDetails.length == 0
      ) {
        newLine.weight = this.shipment.courierWeight.toFixed(1);
      }
      this.proforma.proformaDetails.push(newLine);
    } else {
      this.proforma.proformaDetails = [] as ProformaDetailsManagementDef[];
      if (
        this.shipment &&
        (!this.shipment.proforma ||
          !this.shipment.proforma.proformaDetails ||
          (this.shipment.proforma.proformaDetails &&
            this.shipment.proforma.proformaDetails.length == 0)) &&
        this.weightVisible
      ) {
        newLine.weight = this.shipment.courierWeight.toFixed(1);
      }
      this.proforma.proformaDetails.push(newLine);
    }
    if (this.proforma.proformaDetails.length === 1) this.applyGoodDescription();
  }

  saveProforma(preview?: boolean) {
    if (!this.$v.$invalid) {
      this.checkWeight();
      if (this.shipment.shipmentId) {
        this.proformaService
          .saveProforma(this.shipment.shipmentId, this.proforma)
          .then(res => {
            this.shipment.proforma = this.proforma;
            if (preview) {
              this.previewProforma();
            } else {
              this.$snotify.success(String(this.$t("proforma_message_saved")));
              if (this.showTaxDutyLogic) {
                this.$emit("save-proforma-event", this.proforma);
              } else {
                this.$emit("close");
              }
            }
          })
          .catch(err => {
            return alertDangerReason(
              err,
              this,
              this.$t("FIX_BEFORE_CONTINUE") + ""
            );
          });
      } else {
        this.shipment.proforma = this.proforma;
        this.$emit("save-proforma-event", this.proforma);
        if (preview) {
          this.previewProforma();
        }
      }
    }
  }

  checkWeight() {
    this.proforma.proformaDetails.forEach((d, i) => {
      this.proforma.proformaDetails[i].weight = Number(d.weight);
    });
  }
  openTariffLink() {
    const a: any = document.createElement("A");

    a.href = this.tariffUrl;
    a.setAttribute("target", "_blank");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  printProforma() {
    if (!this.$v.$invalid) {
      this.proformaService
        .printProforma(this.shipment.shipmentId)
        .then(value => {
          popupFileBase64(value, "PDF", "Proforma.pdf", this);
        })
        .catch(err => {
          return alertDangerReason(err, this);
        });
    }
  }

  previewProforma() {
    return this.proformaService
      .previewProforma(
        this.shipment,
        this.$store.getters["customer/info"].tenantId,
        this.$store.getters["customer/info"].multiStoreId
      )
      .then((res: any) => {
        this.openDocumentContentBase64("PDF", res);
      })
      .catch(err => {
        alertDangerReason(err, this);
      });
  }

  // open a base64 document, it an be of various formats based on courier calls
  openDocumentContentBase64(documentType: any, base64File: string) {
    if (documentType === undefined || this.shipment.shipmentId === undefined) {
      return this.$alerts.danger(String(i18n.t("error")));
    }
    // printFileBase64(base64File, documentType, 'document.' + documentType, this);
    popupFileBase64(base64File, documentType, "document." + documentType, this);
  }

  closeModal() {
    this.$emit("close", false);
  }

  onItemsSingleValueChange(data: any) {
    const line: ProformaDetailsManagementDef = data.line;
    const lineIndex: number = data.lineIndex;
    line.itemsTotalValue = parseFloat(
      (line.itemsSingleValue * line.itemsNumber).toFixed(2)
    );
    Vue.set(this.proforma.proformaDetails, lineIndex, line);
    this.setProformaTotal();
  }

  onItemsNumberChange(data: any) {
    const line: ProformaDetailsManagementDef = data.line;
    const lineIndex: number = data.lineIndex;
    line.itemsTotalValue = parseFloat(
      (line.itemsSingleValue * line.itemsNumber).toFixed(2)
    );
    Vue.set(this.proforma.proformaDetails, lineIndex, line);
    this.setProformaTotal();
  }

  deleteLine(data: any) {
    const line: ProformaDetailsManagementDef = data.line;
    const findIndex = this.proforma.proformaDetails.indexOf(line);
    this.proforma.proformaDetails.splice(findIndex, 1);
    this.setProformaTotal();
  }

  setProformaTotal() {
    let calculated = 0;
    if (
      this.proforma.proformaDetails.filter(value => value.type === 1).length ===
      0
    ) {
      calculated = 0;
    } else {
      calculated = this.proforma.proformaDetails
        .filter(value => value.type === 1)
        .reduce((a, b) => a + (b["itemsTotalValue"] || 0), 0);
    }
    this.proforma.totalValue = calculated;
  }

  validateReceiverVat() {
    const customer = JSON.parse(
      JSON.stringify(this.$store.getters["customer/info"])
    );
    return !(
      this.proforma.receiverVatNumber === "" &&
      ((isGermany() &&
        this.shipment.courierId === 13 &&
        customer.b2B &&
        this.shipment.shipmentType != "DOMESTIC") ||
        isPortugal())
    );
  }

  validateProformaVat() {
    const customer = JSON.parse(
      JSON.stringify(this.$store.getters["customer/info"])
    );
    return !(
      this.proforma.vatNumber === "" &&
      ((isGermany() &&
        this.shipment.courierId === 13 &&
        customer.b2B &&
        this.shipment.shipmentType != "DOMESTIC") ||
        isPortugal())
    );
  }
  extractConfiguration(configurations: ConfigurationDTO[], key: string) {
    for (let i = 0; i < configurations.length; i++) {
      if (configurations[i].confKey === key) {
        return configurations[i];
      }
    }
    const aNewItem = {
      confKey: key,
      confValue: ""
    } as ConfigurationDTO;
    configurations.push(aNewItem);
    return aNewItem;
  }

  getTranslationFallback(item: any) {
    if (item.weblateKey && hasTranslation(item.weblateKey)) {
      return this.$t(item.weblateKey);
    }
    return item.description;
  }

  get disableProformaEdit() {
    return (
      this.shipment.status !== "DRAFT_NO_WAYBILL" &&
      this.shipment.status !== "DRAFT_TO_BE_CLOSED" &&
      this.shipment.status !== "FIRST_DRAFT_TO_BE_CLOSED" &&
      this.shipment.shipmentId != null
    );
  }

  get measuresInvalid() {
    let areUnitesUndefined = false;
    this.proforma.proformaDetails.forEach(line => {
      if (
        line.type !== 2 &&
        (!line.measureOfMeasurement ||
          !line.description ||
          !line.weight ||
          line.weight === "0.0" ||
          line.weight <= 0 ||
          line.weight == "NaN")
      ) {
        areUnitesUndefined = true;
      }
    });
    if (!this.proforma.proformaDetails) {
      areUnitesUndefined = true;
    }
    return areUnitesUndefined;
  }

  forToFromSender(tipo?: string) {
    return isFrance && tipo === "IMPORT";
  }

  get fromPhone() {
    if (
      this.shipment.customerDepartment === "" &&
      this.shipment.customerDepartmentId === 0 &&
      !this.forToFromSender(this.shipment.shipmentType)
    ) {
      const contacts = store.getters["customer/info"].address.contactsReference;
      const phone = contacts.filter(e => e.type === "TELEPHONE1")[0];
      return phone ? phone.value : "";
    }
    if (
      this.forToFromSender(this.shipment.shipmentType) ||
      !this.shipment.addressFor.phone
    )
      return this.shipment.addressFrom.phone;
    return this.shipment.addressFor.phone;
  }

  get fromCountryId() {
    if (
      this.shipment.customerDepartment === "" &&
      this.shipment.customerDepartmentId === 0 &&
      !this.forToFromSender(this.shipment.shipmentType)
    )
      return store.getters["customer/info"].address.addresses[0].countryId;
    if (
      this.forToFromSender(this.shipment.shipmentType) ||
      !this.shipment.addressFor.countryId
    )
      return this.shipment.addressFrom.countryId;
    return this.shipment.addressFor.countryId;
  }

  get fromZipCode() {
    if (
      this.shipment.customerDepartment === "" &&
      this.shipment.customerDepartmentId === 0 &&
      !this.forToFromSender(this.shipment.shipmentType)
    )
      return store.getters["customer/info"].address.addresses[0].zipCode;
    if (
      this.forToFromSender(this.shipment.shipmentType) ||
      !this.shipment.addressFor.zipCode
    )
      return this.shipment.addressFrom.zipCode;
    return this.shipment.addressFor.zipCode;
  }

  get fromProvince() {
    if (
      this.shipment.customerDepartment === "" &&
      this.shipment.customerDepartmentId === 0 &&
      !this.forToFromSender(this.shipment.shipmentType)
    )
      return store.getters["customer/info"].address.addresses[0].province;
    if (
      this.forToFromSender(this.shipment.shipmentType) ||
      !this.shipment.addressFor.province
    )
      return this.shipment.addressFrom.province;
    return this.shipment.addressFor.province;
  }

  get fromCity() {
    if (
      this.shipment.customerDepartment === "" &&
      this.shipment.customerDepartmentId === 0 &&
      !this.forToFromSender(this.shipment.shipmentType)
    )
      return store.getters["customer/info"].address.addresses[0].city;
    if (
      this.forToFromSender(this.shipment.shipmentType) ||
      !this.shipment.addressFor.city
    )
      return this.shipment.addressFrom.city;
    return this.shipment.addressFor.city;
  }

  get fromAddress() {
    if (
      this.shipment.customerDepartment === "" &&
      this.shipment.customerDepartmentId === 0 &&
      !this.forToFromSender(this.shipment.shipmentType)
    )
      return store.getters["customer/info"].address.addresses[0].address;
    if (
      this.forToFromSender(this.shipment.shipmentType) ||
      !this.shipment.addressFor.address
    )
      return this.shipment.addressFrom.address;
    return this.shipment.addressFor.address;
  }

  get fromCompanyName() {
    if (
      this.shipment.customerDepartment === "" &&
      this.shipment.customerDepartmentId === 0 &&
      !this.forToFromSender(this.shipment.shipmentType)
    )
      return store.getters["customer/info"].businessName;
    if (
      this.forToFromSender(this.shipment.shipmentType) ||
      !this.shipment.addressFor.companyName
    )
      return this.shipment.addressFrom.companyName;
    return this.shipment.addressFor.companyName;
  }

  /*   get weightVisible() {
    return (
      (this.shipment.courierId === 13 && isGermany()) ||
      (this.shipment.courierId === 4 && isPoland())
    );
  } */

  get isGermanyAndCourierDPD() {
    return isGermany() && this.shipment.courierId == 13;
  }

  get isGermanyAndCourierDHL() {
    return isGermany() && this.shipment.courierId === 4;
  }

  get germany() {
    return isGermany();
  }

  get isGermanyAndCourierUPS() {
    return isGermany() && this.shipment.courierId === 1;
  }

  get uk() {
    return isUk();
  }

  get portugal() {
    return isPortugal();
  }

  get shipmentCustomerWeight() {
    const details = Array.isArray(this.proforma.proformaDetails)
      ? this.proforma.proformaDetails
      : [];
    const totalWeight = details.reduce((accumulator, line) => {
      const weight = Number(line.weight);
      const quantity = Number(line.itemsNumber) || 1;
      return accumulator + (isNaN(weight) ? 0 : weight * quantity);
    }, 0);
    return this.formatNumber(totalWeight, 1);
  }

  get parcels() {
    return this.shipment.shipmentPackages.map((el: any) => el.sequence);
  }

  get isPortugal(): boolean {
    return isPortugal();
  }

  get userLanguage() {
    return this.$store.getters["customer/config"].language as string;
  }

  formatNumber(num: number, decimalPrecision = 2) {
    if (isUk()) {
      numbro.setLanguage("en-GB");
    } else {
      numbro.setLanguage("it-IT");
    }

    const formattedNum = numbro(num).format({
      thousandSeparated: true,
      mantissa: decimalPrecision
    });

    return formattedNum;
  }

  datePickerOptions() {
    if (isPortugal()) {
      return {
        disabledDate: (date: any) => {
          return date > new Date();
        },
        firstDayOfWeek: 0
      };
    } else {
      return {
        firstDayOfWeek: 0
      };
    }
  }

  setDefaultIncoterms() {
    if (
      !this.shipment.customsDutiesToCustomer &&
      !this.shipment.requestedChargeCustomDuties &&
      !this.shipment.ddpZonos
    ) {
      this.selectedIncoterm = {
        value: "DAP",
        label: "DAP"
      };
    }
    if (
      this.shipment.customsDutiesToCustomer ||
      this.shipment.requestedChargeCustomDuties ||
      this.shipment.ddpZonos
    ) {
      this.selectedIncoterm = {
        value: "DDP",
        label: "DDP"
      };
    }
  }

  isIncotermDisabled(incoterm: any) {
    if (["DAP", "DDP"].includes(incoterm.value)) return false;
    return true;
  }

  get incotermsType() {
    return this.shipment.courierId === 3 ? ["DAP"] : ["DAP", "DDP"];
  }
}
